import React, { useRef, useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';

import '../css/category.css';

function Category(props) {
  const categoryContainer = useRef();
  const columContainer = useRef();

  useEffect(() => {
    const container = categoryContainer.current;
    if (container.offsetWidth === 0) {
      document.location.reload();
    }
    columContainer.current.style.height = `${container.offsetWidth}px`;
  }, []);

  window.onorientationchange = function() {
    document.location.reload();
  };

  const categoryPhoto = {
    background: `url(${props.photo}) center/cover no-repeat`,
    boxShadow: `10000px 10000px rgba(0, 0, 0, ${props.overlay}) inset`
  };

  return (
    <Col ref={columContainer} id='category' xs='6' sm='3'>
      <Link
        onClick={e => {
          if (!props.routable) {
            e.preventDefault();
          }
          if (props.popup) {
            props.setPopupOn(true);
          }
          if (props.video) {
            props.setUrl(`${props.url}`);
            props.setVideoTitle(`${props.videoTitle}`);
            props.setDescription(`${props.description}`);
          }
          if (props.image) {
            props.setPhoto(`${props.photo}`);
          }
          if (props.seoAlt) {
            props.setSeoAlt(props.seoAlt);
          }
        }}
        to={`/${props.route}`}
      >
        <div className='main-cont'>
          <div
            style={categoryPhoto}
            ref={categoryContainer}
            className={`category-cont ${props.hover ? 'category-scale' : ''}`}
          >
            <h4>{props.title}</h4>
            <FontAwesomeIcon
              className={`${props.video ? 'show-icon' : ''}`}
              icon={faPlayCircle}
            />
          </div>
        </div>
      </Link>
    </Col>
  );
}

export default Category;
